import styled from 'styled-components';
import {theme} from "@styles/theme";

export const ModalCloseBtn = styled.div<{top?: string; right?: string}>`
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalHeaderWrapper = styled.div<{borderRadius?: string}>`
  position: sticky;
  padding: 16px;
  top: 0;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.basic06};
  background-color: ${theme.colors.basic08};
  border-top-left-radius: ${({borderRadius}) => (borderRadius ? borderRadius : '8px')};
  border-top-right-radius: ${({borderRadius}) => (borderRadius ? borderRadius : '8px')};
`;

export const ModalHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;